export default "__VITE_ASSET__Cpr$8GOz__"